import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ChatTab } from "@/components/ai/ChatTab";
import { WhatIfTab } from "@/components/ai/WhatIfTab";
import { Sparkles, Calculator } from "lucide-react";

export default function AIAnalyst() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="font-heading text-2xl font-bold tracking-tight">AI Portfolio Analyst</h1>
                <p className="text-sm text-muted-foreground">Chat with an AI grounded in your data, or model a what-if scenario</p>
            </div>
            <Tabs defaultValue="chat">
                <TabsList data-testid="ai-tabs">
                    <TabsTrigger value="chat" data-testid="ai-tab-chat"><Sparkles className="w-4 h-4 mr-1.5" />Chat</TabsTrigger>
                    <TabsTrigger value="whatif" data-testid="ai-tab-whatif"><Calculator className="w-4 h-4 mr-1.5" />What-If</TabsTrigger>
                </TabsList>
                <TabsContent value="chat" className="mt-5"><ChatTab /></TabsContent>
                <TabsContent value="whatif" className="mt-5"><WhatIfTab /></TabsContent>
            </Tabs>
        </div>
    );
}
